import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { ControllAppService } from '../../services/controllApp.service';
import { LoginRequestDto } from '../../models/autenticar.request.dto';

@Component({
  selector: 'app-autenticar',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './autenticar.component.html',
  styleUrls: ['./autenticar.component.css'],
})
export class AutenticarComponent {
  mensagem: string = '';
  // coordenadas removidas
  idUsuario: string = '';
  // private locationUpdateSubscription removida
  carregando: boolean = false;
  // localizacaoDisponivel removida
  mostrarSenha = false;
  private errorMessageSubscription: Subscription | undefined;

  constructor(
    private router: Router,
    private authService: AuthService,
    private controllAppService: ControllAppService,
  // ServicoLocalizacao removido
  ) {}

  formulario = new FormGroup({
    userName: new FormControl('', [Validators.required, Validators.minLength(3)]),
    senha: new FormControl('', [Validators.required, Validators.minLength(5)]),
  });

  ngOnInit(): void {
    localStorage.removeItem('usuario');
    


      // Escuta mensagens de erro do AuthService
      this.errorMessageSubscription = this.authService.errorMessage$.subscribe(msg => {
        if (msg) {
          this.carregando = false;
          this.mensagem = msg;
          // Exibe erro com Swal.fire
          import('sweetalert2').then(Swal => {
            Swal.default.fire({
              icon: 'error',
              title: 'Erro de autenticação',
              text: msg,
              confirmButtonText: 'OK',
              allowOutsideClick: true
            });
          });
        }
      });
  }

  autenticarUsuario() {
    if (this.formulario.invalid) {
      this.mensagem = 'Preencha os campos corretamente.';
      return;
    }

    this.carregando = true;
  this.mensagem = 'Autenticando...';

    // Cria um objeto que segue o formato do DTO
    const loginData: LoginRequestDto = {
      userName: this.formulario.get('userName')?.value ?? '',
      senha: this.formulario.get('senha')?.value ?? ''
    };

  // Usa o serviço de autenticação
  this.authService.login(loginData.userName, loginData.senha);
    
    // Define um timeout para atualizar a mensagem caso demore muito
    setTimeout(() => {
      if (this.carregando) {
        this.carregando = false;
        this.mensagem = 'A autenticação está demorando mais que o esperado. Por favor, verifique sua conexão.';
      }
    }, 15000); // 15 segundos
  }

  toggleMostrarSenha(): void {
    this.mostrarSenha = !this.mostrarSenha;
  }

  logout() {
    const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

    if (usuario && usuario.usuarioId) {
      this.controllAppService.atualizarStatusUsuario(usuario.usuarioId, false).subscribe({
        next: () => {
          localStorage.clear();
          this.router.navigate(['/pages/usuarios/autenticar']);
        },
        error: (err) => console.error('Erro ao atualizar status de logout:', err)
      });
    } else {
      console.error('Usuário não encontrado para logout.');
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy(): void {
    // Limpeza de localização removida
    if (this.errorMessageSubscription) {
      this.errorMessageSubscription.unsubscribe();
    }
  }
}